import { useState, useEffect, useRef } from 'react';
const useCountdown = (initialTime = 60, step = 1000) => {

  const [timeRemaining, setTimeRemaining] = useState<number>(initialTime);
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const timer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (timer.current) clearInterval(timer.current);
    };
  }, []);

  const startCountdown = () => {
    if (!timer.current && timeRemaining > 0) {
      setIsRunning(true);
      timer.current = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime > 0) {
            return prevTime - 1;
          } else {
            setIsRunning(false);
            if (timer.current) {
              clearInterval(timer.current);
            }
            timer.current = null;
            return initialTime;
          }
        });
      }, step);
    }
  };

  const restartTime = () => {
    setIsRunning(false);
    if (timer.current) clearInterval(timer.current);
    setTimeRemaining(initialTime);
    timer.current = null;
  };

  return { timeRemaining, isRunning, startCountdown, restartTime };
	
};

export default useCountdown;